import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { ShieldCheck, ShieldOff } from 'lucide-react';
import api from '../lib/api';
import { Button } from './ui/button';
import { Input } from './ui/input';

// v3.21-1843 · Admin-only Finturf LIVE submission switch (default OFF).
export const FinturfLiveGateCard = ({ role }) => {
  const [st, setSt] = useState(null);
  const [confirmId, setConfirmId] = useState('');
  const load = useCallback(() => api.get('/finturf/live-submissions').then((r) => setSt(r.data)).catch(() => setSt(null)), []);
  useEffect(() => { load(); }, [load]);
  if (!st) return null;
  const save = (enabled) => api.put('/finturf/live-submissions', { enabled, confirm_merchant_id: confirmId })
    .then((r) => { setSt({ ...st, ...r.data }); toast.success(enabled ? 'Live Finturf submissions ENABLED' : 'Live Finturf submissions disabled'); setConfirmId(''); })
    .catch((e) => toast.error(e?.response?.data?.detail || 'Failed'));
  const det = st.detected || {};
  return (
    <div className={`rounded-xl border p-4 text-xs ${st.enabled ? 'border-emerald-300 bg-emerald-50' : 'border-amber-300 bg-amber-50'}`} data-testid="finturf-live-gate">
      <div className="flex items-center gap-2 font-semibold text-sm mb-1" data-testid="finturf-live-state">
        {st.enabled ? <ShieldCheck className="h-4 w-4 text-emerald-700" /> : <ShieldOff className="h-4 w-4 text-amber-700" />}
        Live Finturf submissions: {st.enabled ? 'ENABLED' : 'DISABLED'}
      </div>
      <div data-testid="finturf-merchant-id">Token's merchant account ID: <code>{det.merchant_id || 'not verified'}</code>
        {det.total_applications != null && ` · ${det.total_applications} applications · ${det.environment}`}{det.error && ` · ${det.error}`}</div>
      {st.enabled && st.changed_by && <div className="text-slate-500">Enabled by {st.changed_by.email} · {new Date(st.changed_at).toLocaleString()}</div>}
      {role === 'ptc_admin' && (
        <div className="flex items-center gap-2 mt-2">
          {st.enabled ? (
            <Button size="sm" variant="outline" onClick={() => save(false)} data-testid="finturf-live-disable">Disable live submissions</Button>
          ) : (
            <>
              <Input className="h-8 w-[320px] text-xs" placeholder="Type the merchant ID above to confirm" value={confirmId}
                     onChange={(e) => setConfirmId(e.target.value)} data-testid="finturf-live-confirm-id" />
              <Button size="sm" disabled={!det.merchant_id || confirmId.trim() !== det.merchant_id} onClick={() => save(true)} data-testid="finturf-live-enable">Enable</Button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default FinturfLiveGateCard;
